/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leavego1Inputs */

const en_leavego1 = /** @type {(inputs: Leavego1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave`)
};

const de_leavego1 = /** @type {(inputs: Leavego1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlassen`)
};

/**
* | output |
* | --- |
* | "Leave" |
*
* @param {Leavego1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const leavego1 = /** @type {((inputs?: Leavego1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leavego1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leavego1(inputs)
	return de_leavego1(inputs)
});
export { leavego1 as "leaveGo" }